"use client";

import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { BASE_URL } from "../config/apiconfig";

/* ---------------- CONTEXT ---------------- */
const ReviewContext = createContext(null);

export const useReviews = () => {
  const context = useContext(ReviewContext);
  if (!context) {
    throw new Error("useReviews must be used within ReviewProvider");
  }
  return context;
};

/* ---------------- API ENDPOINT ---------------- */
const REVIEW_ENDPOINT = `${BASE_URL}/reviews`;

/* ---------------- NORMALIZER ---------------- */
const normalizeReview = (r) => ({
  id: String(r.id),
  userId: r.user_id,
  userName: r.user_name,
  productId: r.product_id,
  rating: Number(r.rating ?? 0),
  text: r.description ?? "",
  status: r.status ?? "Inactive",
  createdAt: r.create_audit_time,
  image: r.image,
});

/* ---------------- PROVIDER ---------------- */
export const ReviewProvider = ({ children }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchReviews = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await fetch(REVIEW_ENDPOINT);
      const json = await res.json();
      const data = Array.isArray(json?.data)
        ? json.data
        : Array.isArray(json)
        ? json
        : [];
        // console.log("image url example:", `${CDN_URL}/${data[8]?.image}`,`${data[8].user_name}`);
      setReviews(data.map(normalizeReview));
    } catch (err) {

      setError("Failed to load reviews");
      setReviews([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  return (
    <ReviewContext.Provider
      value={{
        reviews,
        loading,
        error,
        refetch: fetchReviews,
      }}
    >
      {children}
    </ReviewContext.Provider>
  );
};
